import {AppRoute} from '../../models/AppRoute';

import allStoresAppRoutes from './allStoresAppRoutes';
import giftCardsStoreAppRoutes from './giftCardsStoreAppRoutes';
import liquorStoreAppRoutes from './liquorStoreAppRoutes';
import {StoreType, TargetStoreType} from './types';

// Drawer-only entries that don't make sense on non-ecommerce stores.
// Stripping the route registration also hides the drawer menu item.
//
// WISHLIST is here because a non-ecommerce store has no add-to-cart, so a wish list has no
// completing action. GIFT_CARDS_OPTIONS was removed from this set by DIS-1538: gift cards
// are bought from a separate gift-card store, not from the selected store.
const NON_ECOM_HIDDEN_ROUTES = new Set<AppRoute>([AppRoute.WISHLIST]);

const appRoutes = (
  ecommerceDisabled: boolean,
  isLoggedIn: boolean,
  storeLoyaltyEnabled: boolean,
) => [
  ...liquorStoreAppRoutes(ecommerceDisabled, isLoggedIn, storeLoyaltyEnabled),
  ...giftCardsStoreAppRoutes,
  ...allStoresAppRoutes,
];

export const getRoutesForStoreType = (
  storeType: StoreType,
  storeLoyaltyEnabled: boolean,
  ecommerceDisabled: boolean = false,
  isLoggedIn: boolean = false,
) => {
  const targetStoreType =
    storeType === StoreType.GiftCardStore
      ? TargetStoreType.GiftCardStore
      : TargetStoreType.LiquorStore;
  return appRoutes(ecommerceDisabled, isLoggedIn, storeLoyaltyEnabled).filter(route => {
    if (ecommerceDisabled && NON_ECOM_HIDDEN_ROUTES.has(route.name)) {
      return false;
    }
    return (
      route.targetStoreType === targetStoreType || route.targetStoreType === TargetStoreType.All
    );
  });
};
